<template>
  <div>
    <div class="flex-content-1">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in activitiesPro"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activeNamesPro.includes(String(index)) ? '#1286FF' : ''"
          :size="activity.size">
          <el-collapse v-model="activeNamesPro">
            <el-collapse-item :title="activitiesPro[index].title" :name="String( index )" :class="{ active: (index + 1) % 2 === 0, 'not-active': (index + 1) % 2 !== 0 }">
              <tabsCommon :detail="activitiesPro[index].details" />
            </el-collapse-item>
          </el-collapse>
        </el-timeline-item>
      </el-timeline>
    </div>
    <div class="pages-list">
      <ELpagination :currentPage="pageInfoPro.pageNum" :total="pageInfoPro.total" :limit="pageInfoPro.pageSize" :small="true" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" />
    </div>
  </div>
</template>

<script>
  import tabsCommon from "./tabsCommon"
  import ELpagination from "../../common/ELpagination"
  // import { Logs } from "@/graphql/PiPLogs.gql"

  export default {
    components: {
			tabsCommon,
			ELpagination
		},
    data () {
      return {
        activitiesPro: [],
        activeNamesPro: [ "0", "1", "2" ],
        pageInfoPro: {
					total: 0,
					pageSize: 10,
					pageNum: 1
				}
      }
    },
    created () {
      this.getUpdatePro()
      const urlPro = "https://api-project.itheima.net/pip-logs/count?type_eq=project"
      this.$axios.get(urlPro).then(r => {
        this.pageInfoPro.total = r.data
      }).catch(() => {})
    },
    methods: {
      // 分页封装
			handleCurrentChange (val) {
        this.pageInfoPro.pageNum = val
        this.getUpdatePro()
      },
      handleSizeChange (val) {
        this.pageInfoPro.pageSize = val
        this.pageInfoPro.pageNum = 1
        this.getUpdatePro()
      },
      getUpdatePro () {
        const { pageSize, pageNum } = this.pageInfoPro
				// this.$apollo.query(
        // {
        //   query: Logs,
        //   variables: {
        //     isPublish: true,
        //     type: "project",
				// 		limit: pageSize,
				// 		start: (pageNum - 1) * pageSize || 0
        //   },
        //   fetchPolicy: 'no-cache'
        // })
        // .then((res) => {
        //   this.activitiesPro = [ ...res.data.pipLogs ]
        // })
        // .catch(() => {
        // })
        this.$axios.get(`https://api-project.itheima.net/pip-logs?_start=${(pageNum - 1) * pageSize}&_limit=${pageSize}&_sort=id:desc&type_eq=project`).then(res => {
          this.activitiesPro = [ ...res.data ]
        })
			}
    }
  }
</script>

<style lang="scss" src="../../../../../styles/updateProject.scss">
</style>